import ResultsServiceModel from '../ResultsServiceModel'

export default class SampleResultModel extends ResultsServiceModel {
  modelName () {
    return 'sample-results'
  }

  defaults () {
    return {
      id: null,
      lims_id: null,
      sample_id: null,
      analyte: null,
      analyte_id: null,
      analysis: null,
      analysis_id: null,
      analysis_modus_v1: null,
      analysis_modus_v2: null,
      value: null,
      value_unit: null,
      value_unit_id: null,
      value_description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }

  mutations () {
    return {
      id: val => this.nullStringMutator(val),
      lims_id: val => this.nullStringMutator(val),
      sample_id: val => this.nullStringMutator(val),
      analyte: val => this.nullStringMutator(val),
      analyte_id: val => this.nullStringMutator(val),
      analysis: val => this.nullStringMutator(val),
      analysis_id: val => this.nullStringMutator(val),
      analysis_modus_v1: val => this.nullStringMutator(val),
      analysis_modus_v2: val => this.nullStringMutator(val),
      value: val => this.nullStringMutator(val),
      value_unit: val => this.nullStringMutator(val),
      value_unit_id: val => this.nullStringMutator(val),
      value_description: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    }
  }
}
